// src/components/dialog/DlgSensorPoolInfo.tsx

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

import { SensorPool } from '@/types/domain/sensor'
import { KARMA_BasicDialog } from '@/types/karma/dialog'

import { DlgCloseButton, HStack } from '../'
import {
  FILTER_ACTIVE_SENSOR,
  FILTER_INACTIVE_SENSOR,
  FILTER_MAIN_SENSOR,
  FILTER_SUB_SENSOR,
} from '../../api/'
import { useSensorPool } from '../../hooks/'

type StatRecordProps = {
  label: any
  value: any
}

const StatRecord = ({ label, value, ...rest }: StatRecordProps) => (
  <HStack spacing={2} sx={{ width: 1 }} {...rest}>
    <Stack sx={{ flex: 1, textAlign: 'right' }}>
      <Typography>{label}</Typography>
    </Stack>

    <Stack sx={{ flex: 1, textAlign: 'left' }}>
      <Typography>{value}</Typography>
    </Stack>
  </HStack>
)

const SensorPoolStat = () => {
  const sPool: SensorPool = useSensorPool()

  return (
    <Stack sx={{ mt: 3 }}>
      <StatRecord label={'Poolgröße'} value={sPool.length} />

      {[
        {
          label: 'aktiviert',
          value: sPool.filter(FILTER_ACTIVE_SENSOR).length,
        },
        {
          label: 'deaktiviert',
          value: sPool.filter(FILTER_INACTIVE_SENSOR).length,
        },
        {
          label: 'Provider',
          value: [...new Set(sPool.map(i => i.attributes.provider))].length,
        },
        {
          label: 'Sensor Typen',
          value: [...new Set(sPool.map(i => i.attributes.sensor_type))].length,
        },
        {
          label: 'Sensor Targets',
          value: [...new Set(sPool.map(i => i.attributes.sensor_target))]
            .length,
        },
        {
          label: 'Sub Sensor Targets',
          value: [...new Set(sPool.map(i => i.attributes.sub_sensor_target))]
            .length,
        },
        {
          label: 'Hauptzähler',
          value: sPool.filter(FILTER_MAIN_SENSOR).length,
        },
        {
          label: 'Unterzähler',
          value: sPool.filter(FILTER_SUB_SENSOR).length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}
    </Stack>
  )
}

export const DlgSensorPoolInfo = ({ onClose, open }: KARMA_BasicDialog) => (
  <Dialog fullWidth open={open}>
    <DialogTitle>
      <Typography>Sensor Pool Info</Typography>

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent>
      <SensorPoolStat />
    </DialogContent>
  </Dialog>
)
